import React, {Component} from 'react';
import YouTube  from 'react-youtube';
import StepPreview from 'components/stepPreview';
import ExpandableLI from 'components/expandableLI';
import HIWsection from 'components/HIWsection';
import ScrollIndicator from 'components/scrollIndicator';
import SmallInfoBox from 'components/smallInfoBox';
import {imageUrl, isMobile, isTablet, rootUrl, appUrl} from 'helpers/ApplicationHelper';
import {HIWdata} from 'constants/howItWorks';

class HowItWorks extends Component {

    constructor(props){
        super(props);
        this.navRefs = {};
        ['sectionTop', 'section01', 'section02', 'section03','sectionAllSet', 'sectionYoutube', 'sectionFAQ', 'sectionNeedHelp'].map((ref)=>{
            this.navRefs[ref] = React.createRef();
        })

        this.state = {
            isMobile: false,
            isTablet: false
        }
    }

    componentDidMount() {
        this.setState({
            isMobile: isMobile(),
            isTablet: isTablet()
        });
    }

    render(){
        let that = this;
        const scrollIndicator =  !this.state.isTablet && !this.state.isMobile? <ScrollIndicator refs={this.navRefs} startPos={'sectionTop'}/> : '';
        const patternBgkLight = !this.state.isTablet && !this.state.isMobile ? {backgroundImage: `url("${imageUrl("howItWorks/backgrounds/backgroundPattern-light.png")}")`} : {};
        return (
            <div className="hiw-container">
                {scrollIndicator}
                <div className="top-container" style={patternBgkLight} ref={this.navRefs.sectionTop}>
                    <div className="inner-container">
                        <div className="top-section">
                            <h1 className='section-header main-header'>{HIWdata.mainPage.mainTitle}</h1>
                            <h3>{HIWdata.mainPage.subTitle}</h3>
                            <div className="steps-container">
                                {HIWdata.stepPreviewData.map(prev => {
                                    return <StepPreview 
                                                key={prev.stepNum} 
                                                stepNum={prev.stepNum} 
                                                stepDesc={prev.stepDesc} 
                                                stepImg={prev.stepImg} 
                                                stepReverseMobile={prev.reverseMobile}/>
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                {HIWdata.sectionsData.map((section,i) =>{
                    return <HIWsection key={i} section={section} inref={that.navRefs['section'+section.stepNum]}/>
                })}
                <div className="all-set-container" ref={this.navRefs.sectionAllSet}>
                    <div className='inner-container'>
                        <h2 className='section-header'> {HIWdata.mainPage.allSetTitle} </h2>
                        <p className='all-set-text'>{HIWdata.mainPage.allSetText}</p>
                        <button className="btn btn-gold redirect-btn all-set" onClick={()=>{window.location=appUrl()+"/submit/multiple_jewelry"}}>{HIWdata.mainPage.allSetBtn}</button>
                    </div>
                </div>
                <div className="youtube-container" ref={this.navRefs.sectionYoutube}>
                    <YouTube videoId="aKv0f24KRRs" onReady={this._onReady} opts={this.playerOpts()}/>
                </div>
                <div className="faq-container" ref={this.navRefs.sectionFAQ}>
                    <div className="inner-container">
                        <h2 className='section-header'> {HIWdata.mainPage.faqTitle} </h2>
                        <ul className="faq-list-items">
                            {HIWdata.faqData.map((listItem,i) =>{
                            const hr = (i === HIWdata.faqData.length-1) ? '' : <hr/>;
                            return (
                            <React.Fragment key={i}>
                                <ExpandableLI expandText={listItem.expandText} bullet={listItem.bullet} plusColor={'white'}/> 
                                {hr}
                            </React.Fragment>
                            )})}
                        </ul>
                        <button className="btn btn-reverse redirect-btn faq" onClick={()=>{window.location.href=rootUrl()+"/about/faqs"}}>
                            {HIWdata.mainPage.faqBtn}
                            <div className="arrow"/>
                        </button>
                    </div>
                </div>
                <div className="need-help-container" ref={this.navRefs.sectionNeedHelp}>
                    <div className="inner-container">
                        <h2 className='title section-header'>  {HIWdata.mainPage.needHelpTitle}</h2>
                        <div className="contact-ways-container">
                            {HIWdata.needHelpData.map((info,i) => {
                                return (<SmallInfoBox key={i} icon={info.icon} title={info.title} text={info.text}/>)
                            })}
                        </div>
                    <button className="btn btn-gold redirect-btn need-help" onClick={()=>{window.location=appUrl()+"/submit/multiple_jewelry"}}>{HIWdata.mainPage.needHelpBtn}</button>
                    </div>
                </div>
            </div>
        );
    }

    _onReady(event) {event.target.pauseVideo();}  // access to player in all event handlers via event.target
    
    playerOpts = () => {return { width: '100%', height: '500', playerVars: {modestbranding: 1, rel: 0, color: 'white'}}}
}

export default HowItWorks;